import html from '../legacy/df.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Diffusion() {
  return <LegacyHtmlPage slug="df" title="Diffusion Models" html={html} />;
}
